<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="modal.show"
                   :title="$t('Increments')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <increment-tiers :model="model" attribute="increments"/>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import IncrementsModel from "./IncrementsModel.model";
  import IncrementTiers from "../../../../../core/components/increment-tiers/IncrementTiers";
  import Increment from "../../../../../core/components/increment-tiers/Increment.model";

  const {mapState, mapActions} = createNamespacedHelpers('sales');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "IncrementsModal",
    components: {IncrementTiers, InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new IncrementsModel(),
      }
    },
    methods: {
      ...mapActions(['showIncrementModal', 'hideIncrementModal', 'postIncrements']),
      async onSubmit() {

        let requestData = this.model.increments.map(increment => {
          return {...increment.toJSON(), auction_uuid: this.modal.auction_uuid}
        });

        this.loading = true;
        let response = await this.postIncrements(requestData);
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.$toast('success', this.$t('Increments were successfully saved'));
          this.hideIncrementModal();
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            for (let index in response.body) {
              this.model.increments[index].setMultipleErrors(response.body[index]);
            }
          }
        }
      },
      onShow() {
        this.initIncrements();
      },
      onHidden() {
        this.model = new IncrementsModel();
        this.hideIncrementModal();
      },
      initIncrements() {
        this.model = new IncrementsModel({increments: this.editObjects.map(data => new Increment(data))});
      },
    },
    watch: {
      editObjects() {
        this.initIncrements();
      }
    },
    computed: {
      ...mapState({
        modal: state => state.view.incrementData.modal,
        editObjects: state => state.view.incrementData.modal.objects
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>

